import { Button, ButtonProps } from 'antd';
import styled, { css } from 'styled-components';
import { COLORS, pickThemeFontSize, pickThemeFontStyles } from '@/theme';

const getStylesByType = (type: ButtonProps['type']) => {
  switch (type) {
    case 'primary':
      return css`
        background: ${COLORS.YELLOW_PRIMARY};
        color: ${COLORS.BLACK_PRIMARY};

        :hover {
          background: ${COLORS.YELLOW_PRIMARY};
          color: ${COLORS.BLACK_PRIMARY};
        }
      `;
    case 'text':
      return css`
        background: ${COLORS.YELLOW_PRIMARY};
        color: ${COLORS.BLACK_PRIMARY};

        :hover {
          background: ${COLORS.YELLOW_PRIMARY};
          color: ${COLORS.BLACK_PRIMARY};
        }
      `;
    case 'link':
    case 'dashed':
      return css``;
    case 'default':
      return css`
        border: 1px solid ${COLORS.BLACK_PRIMARY};
        color: ${COLORS.BLACK_PRIMARY};

        :hover {
          border: 1px solid ${COLORS.BLACK_PRIMARY};
          color: ${COLORS.BLACK_PRIMARY};
        }
      `;
    default:
      return css`
        border: 1px solid ${COLORS.BLACK_PRIMARY};
        color: ${COLORS.BLACK_PRIMARY};

        :hover {
          border: 1px solid ${COLORS.BLACK_PRIMARY};
          color: ${COLORS.BLACK_PRIMARY};
        }
      `;
  }
};

const getStylesBySize = (size: ButtonProps['size']) => {
  switch (size) {
    case 'small': {
      return css``;
    }
    case 'large':
      return css`
        height: 3rem;
      `;
    case 'middle':
      return css`
        height: 2rem;
      `;
    default:
      return css``;
  }
};

export const StyledButton = styled(Button)`
  &.ant-btn.template-button {
    ${pickThemeFontStyles('14', '22', 'NORMAL')};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: none;
    height: auto;
    padding: 0 1rem;
    border-radius: 0.25rem;

    & .anticon {
      ${pickThemeFontStyles('24', '24')};
      height: ${pickThemeFontSize('24')};
    }

    ${(props) => getStylesBySize(props.size)}

    ${(props) =>
      props.danger
        ? css`
            background: ${COLORS.RED};
            border: 1px solid ${COLORS.RED};
            color: ${COLORS.WHITE};

            :hover {
              background: ${COLORS.RED};
              border: 1px solid ${COLORS.RED};
              color: ${COLORS.WHITE};
            }
          `
        : getStylesByType(props.type)}

    &.template-button--danger-brand.ant-btn-dangerous {
      background: ${COLORS.YELLOW_PRIMARY};
      border: 1px solid ${COLORS.BLACK_PRIMARY};
      color: ${COLORS.BLACK_PRIMARY};

      :hover {
        background: ${COLORS.YELLOW_PRIMARY};
        border: 1px solid ${COLORS.BLACK_PRIMARY};
        color: ${COLORS.BLACK_PRIMARY};
      }
    }
  }
`;
